import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceGroupUpsertClientsDialogStore } from './service-group-upsert-clients-dialog.store';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { fb } from '../../../../../shared/shared.global-service';
import { AppFormGroup } from '../../../../../../utils/form.utils';
import { contentGlobalSuccess } from '../../../../content.error';
import {
    FolderGroupAddFoldersInput,
} from '@libs/types/src/services/input-type/folder/folder-group.add-folders-input';
import { SearchFoldersComponent } from '../../../common/search-folders/search-folders.component';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';

@Component({
    selector: 'app-service-groups-upsert-clients-dialog',
    templateUrl: 'service-group-upsert-clients-dialog.component.html',
    styleUrl: 'service-group-upsert-clients-dialog.component.scss',
    providers: [ServiceGroupUpsertClientsDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        SearchFoldersComponent,
        DateInputComponent,
    ],
})
export class ServiceGroupUpsertClientsDialogComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceGroupUpsertClientsDialogStore);

    protected serviceId!: number;
    protected folderIds!: number[];
    protected groupId!: number;

    protected form = new AppFormGroup({
        validFrom: fb.control<Date>(new Date()),
        validTo: fb.control<Date | null>(null),
        folderIds: fb.control<number[]>([], Validators.required),
    });

    constructor() {
        super();
        this.serviceId = this.dialogConfig.data.serviceId;
        this.folderIds = this.dialogConfig.data.folderIds || [];
        this.groupId = this.dialogConfig.data.groupId;
    }

    override save(_event: Event): void | Promise<void> {
        if (isInvalid(this.form) || !this.groupId) return;

        const data = {
            groupId: this.dialogConfig.data.groupId,
            folderIds: this.form.value.folderIds!,
            validFrom: this.form.value.validFrom,
            validTo: this.form.value.validTo,
            creditGroup: this.dialogConfig.data.creditGroup === true,
        };

        this.store.api
            .addFoldersToFolderGroup(data as FolderGroupAddFoldersInput)
            .then(() => {
                contentGlobalSuccess.next('common.created');
                this.dialogRef.close({ refresh: true });
            });
    }
}
